"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customPreload = void 0;
const customPreloadBase_1 = __importDefault(require("../../common/customPreloadBase"));
const sectionConfigs_1 = require("./sectionConfigs");
// Do some actions before the section is loaded
const customPreload = function (interview, { startUpdateInterview, callback }) {
    const responsesContent = (0, customPreloadBase_1.default)(interview, sectionConfigs_1.currentSectionName);
    startUpdateInterview({ sectionShortname: sectionConfigs_1.currentSectionName, valuesByPath: responsesContent }, callback);
    return null;
};
exports.customPreload = customPreload;
